// @flow
import $ from 'jquery';
import _ from 'lodash';
import { makeRequest } from './request';

const select: Object = $('.js-ajaxselect');

/**
 * Wysyła formularz i odświeza datatables
 * @param {jQuery} form - obiekt formularza
 * @returns {Function} - wykonuje makeRequest i odswieza tabelke
 */
function sendForm(form: Object): Function {
    const tablename = form.attr('data-tablename');
    const url = form.attr('action');
    const method = form.attr('method');
    const payload = {};

    return makeRequest({ url, method, payload }, () => {
        refreshTable(datatablesArr[tablename]);
    });
}

function init() {
    if (select.length) {
        select.on('submit', function (e) {
            sendForm($(this));
            e.preventDefault();
        });
    }
}

export { init };



// WEBPACK FOOTER //
// ./src/_app/layout/selectAjax.js